import styled, { keyframes } from "styled-components";
import { colors } from "../../styles/colors";

export const LoginContainer = styled.div`
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const LoginContent = styled.div`
  max-width: 400px;
  width: 100%;
  background-color: ${colors.white};
  border-radius: 20px;
  padding: 40px 32px;
  box-shadow: 0 8px 32px ${colors.darkBlueAlpha59};
  text-align: center;
  direction: rtl;

  @media (max-width: 768px) {
    padding: 32px 24px;
    border-radius: 16px;
  }

  @media (max-width: 480px) {
    padding: 24px 20px;
  }
`;

export const LogoWrapper = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, ${colors.gradientTeal}, ${colors.gradientBlue});
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  box-shadow: 0 8px 24px rgba(0, 78, 247, 0.2);

  @media (max-width: 768px) {
    width: 64px;
    height: 64px;
    margin-bottom: 20px;
  }
`;

export const Title = styled.h1`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: ${colors.darkBlue};
  margin: 0 0 8px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 16px;
  color: ${colors.blueGray};
  margin: 0 0 32px 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 24px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LoginButton = styled.button<{ $variant: "google" | "passkey" }>`
  font-family: "Noto Sans Hebrew", sans-serif;
  width: 100%;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 52px;
  border: none;

  ${({ $variant }) =>
    $variant === "google"
      ? `
    background: ${colors.white};
    color: ${colors.darkBlue};
    border: 2px solid ${colors.lightGrayBlue};

    &:hover:not(:disabled) {
      background: ${colors.lightGray};
      border-color: ${colors.blueGray};
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  `
      : `
    background: linear-gradient(135deg, ${colors.gradientTeal}, ${colors.gradientBlue});
    color: ${colors.white};
    box-shadow: 0 4px 12px rgba(0, 78, 247, 0.3);

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 8px 20px rgba(0, 78, 247, 0.4);
    }
  `}

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 15px;
    min-height: 48px;
  }
`;

export const GoogleIcon = styled.svg`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const ErrorMessage = styled.div`
  color: ${colors.red};
  font-size: 14px;
  font-family: "Noto Sans Hebrew", sans-serif;
  margin-top: 16px;
  text-align: center;
  line-height: 1.4;
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;
